/*
 * @providesModule SKZCloudGaming
 */
//This file has been created for Cloud Gaming feature, the bridge does not exist in iOS as cloud emulator as Android 
// (so defaulting to isCloudGaming=false and not acting on any functions)
import {noop} from 'lodash';
import {NativeModules} from 'react-native';

type SKZCloudGamingType={
    getConstants:()=>{isCloudGaming:boolean, webDepositEnabled:boolean, webSaveAccountEnabled:boolean};
    sendMessageCloud: (topic:string, data:Object, callback:(error:string, success:boolean)=>void) =>void;
    subscribeMessaging: (topic:string, caller:string, callback:(jsonObject:string)=>void) =>void;
    unsubscribeMessaging: (topic:String, caller:string, callback:(error:string, success:boolean)=>void) =>void;
}

const SKZCloudGaming:SKZCloudGamingType = NativeModules.SKZCloudGaming ||
{
  getConstants: () => ({isCloudGaming: false, webDepositEnabled: false, webSaveAccountEnabled: false}),
  sendMessageCloud: noop,
  subscribeMessaging: noop,
  unsubscribeMessaging: noop,

};

export default SKZCloudGaming;
